// extracted by mini-css-extract-plugin
export default {"instructionsSectionImage":"InstructionsSectionImage_instructionsSectionImage__0gFKT"};